export default class Cart {
  constructor() {
    this.cartForm = document.querySelector('.js-cart-form');
    this.body = document.body;
    this.cartTimeout = null;

    if (this.cartForm) {
      Cart.init();
    }

    if (window.location.hostname === 'shop.coavacoffee.com') {
      Cart.updateCartCount();
    }

    document.querySelectorAll('.js-qty_adjust').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        Cart.adjustQuantity(event.currentTarget);
        document.querySelector('.js-cart_update').classList.add('cart-update--changed');
      });
    });
  }

  static updateCartNote(note) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: `note=${note}`,
    })
      .then(response => response.json())
      .then(() => {
        console.log(`Cart note updated to ${note}`);
      })
      .catch((error) => {
        console.log(`Cart note error ${error}. Not updated to ${note}`);
      })
      .finally(() => {
        console.log('Done trying to update cart note.');
      });
  }

  static init() {
    document.body.addEventListener('change', (event) => {
      if (event.target.matches('textarea[name="note"]')) {
        Cart.updateCartNote(event.target.value);
      }
    });
  }

  static adjustQuantity(element) {
    const qtySelector = element.parentNode.querySelector('.js-qty');

    let qty = parseInt(qtySelector.value.replace(/\D/g, ''), 10);
    qty = Cart.validateQty(qty);

    if (element.classList.contains('js-qty_adjust--increase')) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 1) {
        qty = 1;
      }
    }
    qtySelector.value = qty;
    return qtySelector;
  }

  static validateQty(qty) {
    if (parseFloat(qty) === parseInt(qty, 10) && !Number.isNaN(qty)) {
      return qty;
    }
    return 1;
  }

  static updateCartCount() {
    const cartCount = document.querySelector('.js-cart_count');

    fetch('https://shop.coavacoffee.com/cart.json')
      .then(response => response.json())
      .then(data => {
        const itemCount = data.item_count;
        if (itemCount > 0) {
          cartCount.textContent = itemCount;
        }
      });
  }
}
